"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.promoVideoComponent = exports.PromoVideoComponent = void 0;
var tslib_1 = require("tslib");
var app_1 = require("app");
var PreviewBox_1 = require("../PreviewBox/PreviewBox");
var PromoVideoComponent = /** @class */ (function (_super) {
    tslib_1.__extends(PromoVideoComponent, _super);
    function PromoVideoComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selector = '.full-bleed-image-spot .card__cta .cta-video';
        return _this;
    }
    PromoVideoComponent.prototype.OnInit = function () {
        document.querySelectorAll('.full-bleed-image-spot').forEach(function (el) {
            var externalLink = new app_1.ExternalLink(el.querySelectorAll('a'));
            externalLink.checkLinks();
        });
        this.el.forEach(function (el) {
            el.addEventListener('click', function (event) {
                (0, PreviewBox_1.showPreviewBoxWithDataFromImage)(event, el);
            });
            el.addEventListener('keypress', function (event) {
                if (event.key === app_1.keyNameMapping.enter || event.key === app_1.keyNameMapping.space) {
                    (0, PreviewBox_1.showPreviewBoxWithDataFromImage)(event, el);
                }
            });
        });
    };
    return PromoVideoComponent;
}(app_1.Component));
exports.PromoVideoComponent = PromoVideoComponent;
exports.promoVideoComponent = new PromoVideoComponent();
